import { useState, useCallback, useEffect } from 'react';

import {
    BrowserRouter,
    Routes,
    Route,
    Navigate
} from 'react-router-dom';

import rsa from 'jsrsasign';

import axios from 'axios';

import HomePage from './components/HomePage';

import PesqueriaDesarrolloPage from './views/pesqueria-desarrollo/page';
import PesqueriaNuevoV1Page from './views/pesqueria-nuevo/v1/page';
import PesqueriaNuevoV2Page from './views/pesqueria-nuevo/v2/page';
import PesqueriaNuevoV3Page from './views/pesqueria-nuevo/v3/page';
import PoliticasPrivacidadPesqueriaPage from './views/pesqueria-nuevo/politicas-privacidad/page';
import TerminosUsoPesqueriaPage from './views/pesqueria-nuevo/terminos-de-uso/page';
import AcuiculturaPage from './views/acuicultura/page';
import AcuiculturaDesarrolloPage from './views/acuicultura-desarrollo/page';
import AcuiculturaNuevoV1Page from './views/acuicultura-nuevo/v1/page';
import PoliticasPrivacidadAcuiculturaPage from './views/acuicultura-nuevo/politicas-privacidad/page';
import TerminosUsoAcuiculturaPage from './views/acuicultura-nuevo/terminos-de-uso/page';
import DashboardPage from './views/dashboard/page';
import DashboardAcuiculturaPage from './views/dashboard-acuicultura/page';

const App = () => {
    const [autocompletado, setAutocompletado] = useState('');
    const [selected, setSelected] = useState('');
    const [buscador, setBuscador] = useState({});
    const [options, setOptions] = useState([]);
    const [multiSelector, setMultiSelector] = useState([]);
    const [anioDesde, setAnioDesde] = useState(null);
    const [anioHasta, setAnioHasta] = useState(null);
    const [checking, setChecking] = useState(false);
    const [codigos, setCodigos] = useState([]);
    const [codigosProyectos, setCodigosProyectos] = useState([]);
    const [checkboxesProyectos, setCheckboxesProyectos] = useState({});
    const [proyectos, setProyectos] = useState([]);
    const [añosDisponibles, setAñosDisponibles] = useState([]);
    const [checkboxesAños, setCheckboxesAños] = useState({});
    const [años, setAños] = useState([]);
    const [codigosEspecies, setCodigosEspecies] = useState([]);
    const [checkboxesEspecies, setCheckboxesEspecies] = useState({});
    const [especies, setEspecies] = useState([]);
    const [codigosPuertos, setCodigosPuertos] = useState([]);
    const [checkboxesPuertos, setCheckboxesPuertos] = useState({});
    const [puertos, setPuertos] = useState([]);
    const [codigosRegiones, setCodigosRegiones] = useState([]);
    const [checkboxesRegiones, setCheckboxesRegiones] = useState({});
    const [regiones, setRegiones] = useState([]);
    const [codigosSectores, setCodigosSectores] = useState([]);
    const [checkboxesSectores, setCheckboxesSectores] = useState({});
    const [sectores, setSectores] = useState([]);
    const [sorting, setSorting] = useState(false);
    const [orderbyAño, setOrderbyAño] = useState(0);
    const [orderbyProyecto, setOrderbyProyecto] = useState(0);
    const [orderbyInformacion, setOrderbyInformacion] = useState(0);
    const [orderbyEspecie, setOrderbyEspecie] = useState(0);
    const [orderbyRegion, setOrderbyRegion] = useState(0);
    const [orderbyPuerto, setOrderbyPuerto] = useState(0);
    const [orderbySector, setOrderbySector] = useState(0);
    const [orderbyRegistros, setOrderbyRegistros] = useState(0);
    const [orderby, setOrderby] = useState('');
    const [order, setOrder] = useState('');
    const [archivos, setArchivos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pages, setPages] = useState([]);
    const [pagination, setPagination] = useState(1);
    const [from, setFrom] = useState(0);
    const [lastPage, setLastPage] = useState(0);
    // const [items, setItems] = useState(0);
    const [to, setTo] = useState(0);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(false);
    const [status422, setStatus422] = useState(false);
    const [opcionesSelector, setOpcionesSelector] = useState('');
    const [añosSelector, setAñosSelector] = useState('');
    const [timestamp, setTimestamp] = useState('');

    const apiUrl = process.env.REACT_APP_API_URL;
    const publicUrl = process.env.PUBLIC_URL;

    const verifyToken = (response, appDebug, secretKey) => {
        const { data } = response;

        if (appDebug === 'true') { return data; }

        const isValid = rsa.KJUR.jws.JWS.verify(data, secretKey, ['HS256']);

        if (!isValid) { return []; }

        const payload = rsa.jws.JWS.readSafeJSONString(rsa.b64utoutf8(data.split('.')[1]));

        return payload;
    }

    const handlePagination = (setPages, pagination, lastPage) => {
        const array = [];

        for (let i = 1; i < (pagination + 3); i++) {
            if (i < lastPage + 1) {
                array.push({ 'page': i });
            }
        }

        const pages = [];

        array.map(page =>
        (
            page.page > pagination - 3 && pages.push(page)
        ));

        setPages(pages);
    }

    const handleSelector = () => {
        let opcionesSelector = '';

        multiSelector.map((data, index, array) =>
        (
            opcionesSelector += index === array.length - 1 ? data.label : `${data.label}, `
        ));

        const añosSelector = `${anioDesde} y ${anioHasta}`;

        setOpcionesSelector(opcionesSelector);
        setAñosSelector(añosSelector);
    }

    const handleChange = async (e) => {
        console.log(new Error('This handle is deprecated.'));

        // const label = e.label.replace(/Especie: |Nombre Científico: |Puerto: |Región: |Proyecto: |Tipo de información: |Año: /g, '');

        // setSelected({ value: e.value, label: label });
        // setBuscador({ value: e.value, label: label });
        // setPagination(1);

        // try
        // {
        //     const busqueda = await axios.get(`${apiUrl}/busqueda?${e.value}=${label}&registros=1`);

        //     setCodigos(busqueda.data.codigos);
        //     setProyectos(busqueda.data.proyectos);
        //     setAños(busqueda.data.anios);
        //     setEspecies(busqueda.data.especies);
        //     setPuertos(busqueda.data.puertos);
        //     setRegiones(busqueda.data.regiones);

        //     const archivos = await axios.get(`${apiUrl}/archivos?${e.value}=${label}`);

        //     setCodigosProyectos([]);
        //     setCheckboxesProyectos({});
        //     setAnios([]);
        //     setMultiSelector([]);
        //     setCodigosEspecies([]);
        //     setCheckboxesEspecies({});
        //     setCodigosPuertos([]);
        //     setCheckboxesPuertos({});
        //     setCodigosRegiones([]);
        //     setCheckboxesRegiones({});
        //     setArchivos(archivos.data.data);

        //     const from = archivos.data.meta.from;
        //     const lastPage = archivos.data.meta.last_page;
        //     const perPage = archivos.data.meta.per_page;
        //     const to = archivos.data.meta.to;
        //     const total = archivos.data.meta.total;

        //     handlePagination(setPages, pagination, lastPage);

        //     setFrom(from);
        //     setLastPage(lastPage);
        //     setItems(perPage);
        //     setTo(to);
        //     setTotal(total);
        // }
        // catch (error)
        // {
        //     console.error(error);
        // }
    }

    const handleInputChange = (e) => {
        console.log(new Error('This handle is deprecated.'));

        setAutocompletado(e);
    }

    const handleSearch = async () => {
        console.log(new Error('This handle is deprecated.'));

        // setSelected('');
        // setBuscador({});
        // setPagination(1);

        // try
        // {
        //     const busqueda = await axios.get(`${apiUrl}/busqueda?registros=1`);

        //     setCodigos(busqueda.data.codigos);
        //     setProyectos(busqueda.data.proyectos);
        //     setAños(busqueda.data.anios);
        //     setEspecies(busqueda.data.especies);
        //     setPuertos(busqueda.data.puertos);
        //     setRegiones(busqueda.data.regiones);

        //     const archivos = await axios.get(`${apiUrl}/archivos`);

        //     setCodigosProyectos([]);
        //     setCheckboxesProyectos({});
        //     setAnios([]);
        //     setMultiSelector([]);
        //     setCodigosEspecies([]);
        //     setCheckboxesEspecies({});
        //     setCodigosPuertos([]);
        //     setCheckboxesPuertos({});
        //     setCodigosRegiones([]);
        //     setCheckboxesRegiones({});
        //     setArchivos(archivos.data.data);

        //     const from = archivos.data.meta.from;
        //     const lastPage = archivos.data.meta.last_page;
        //     const perPage = archivos.data.meta.per_page;
        //     const to = archivos.data.meta.to;
        //     const total = archivos.data.meta.total;

        //     handlePagination(setPages, pagination, lastPage);

        //     setFrom(from);
        //     setLastPage(lastPage);
        //     setItems(perPage);
        //     setTo(to);
        //     setTotal(total);
        // }
        // catch (error)
        // {
        //     console.error(error);
        // }
    }

    // const fetchData = useCallback(async () =>
    // {
    //     try
    //     {
    //         const { data } = await axios.get(`${apiUrl}/autocompletado?autocompletado=${autocompletado}`);

    //         const array = data.data.map((data) => ({ value: data.tipo.toLowerCase(), label: data.texto + data.parametro }));

    //         setOptions(array);
    //     }
    //     catch (error)
    //     {
    //         console.error(error);
    //     }
    // }, [apiUrl, autocompletado]);

    useEffect(() => {
        if (autocompletado.length > 2) {
            setSelected('');

            // fetchData();
        }
        else {
            setOptions([]);
        }
        // }, [fetchData, autocompletado, checkboxesProyectos]);
    }, [autocompletado, checkboxesProyectos]);

    return (
        <BrowserRouter basename={publicUrl}>
            {/* Routes */}
            <Routes>
                {/* HomePage */}
                <Route
                    path="/buscador-experto"
                    element=
                    {
                        <HomePage
                            verifyToken={verifyToken}
                            selected={selected}
                            setSelected={setSelected}
                            buscador={buscador}
                            setBuscador={setBuscador}
                            options={options}
                            multiSelector={multiSelector}
                            setMultiSelector={setMultiSelector}
                            anioDesde={anioDesde}
                            setAnioDesde={setAnioDesde}
                            anioHasta={anioHasta}
                            setAnioHasta={setAnioHasta}
                            checking={checking}
                            setChecking={setChecking}
                            codigos={codigos}
                            setCodigos={setCodigos}
                            codigosProyectos={codigosProyectos}
                            setCodigosProyectos={setCodigosProyectos}
                            checkboxesProyectos={checkboxesProyectos}
                            setCheckboxesProyectos={setCheckboxesProyectos}
                            proyectos={proyectos}
                            setProyectos={setProyectos}
                            añosDisponibles={añosDisponibles}
                            setAñosDisponibles={setAñosDisponibles}
                            checkboxesAños={checkboxesAños}
                            setCheckboxesAños={setCheckboxesAños}
                            años={años}
                            setAños={setAños}
                            codigosEspecies={codigosEspecies}
                            setCodigosEspecies={setCodigosEspecies}
                            checkboxesEspecies={checkboxesEspecies}
                            setCheckboxesEspecies={setCheckboxesEspecies}
                            especies={especies}
                            setEspecies={setEspecies}
                            codigosPuertos={codigosPuertos}
                            setCodigosPuertos={setCodigosPuertos}
                            checkboxesPuertos={checkboxesPuertos}
                            setCheckboxesPuertos={setCheckboxesPuertos}
                            puertos={puertos}
                            setPuertos={setPuertos}
                            codigosRegiones={codigosRegiones}
                            setCodigosRegiones={setCodigosRegiones}
                            checkboxesRegiones={checkboxesRegiones}
                            setCheckboxesRegiones={setCheckboxesRegiones}
                            regiones={regiones}
                            setRegiones={setRegiones}
                            sorting={sorting}
                            setSorting={setSorting}
                            orderbyAño={orderbyAño}
                            setOrderbyAño={setOrderbyAño}
                            orderbyProyecto={orderbyProyecto}
                            setOrderbyProyecto={setOrderbyProyecto}
                            orderbyInformacion={orderbyInformacion}
                            setOrderbyInformacion={setOrderbyInformacion}
                            orderbyEspecie={orderbyEspecie}
                            setOrderbyEspecie={setOrderbyEspecie}
                            orderbyRegion={orderbyRegion}
                            setOrderbyRegion={setOrderbyRegion}
                            orderbyPuerto={orderbyPuerto}
                            setOrderbyPuerto={setOrderbyPuerto}
                            orderbyRegistros={orderbyRegistros}
                            setOrderbyRegistros={setOrderbyRegistros}
                            orderby={orderby}
                            setOrderby={setOrderby}
                            order={order}
                            setOrder={setOrder}
                            archivos={archivos}
                            setArchivos={setArchivos}
                            loading={loading}
                            setLoading={setLoading}
                            handlePagination={handlePagination}
                            handleSelector={handleSelector}
                            handleChange={handleChange}
                            handleInputChange={handleInputChange}
                            handleSearch={handleSearch}
                            pages={pages}
                            setPages={setPages}
                            pagination={pagination}
                            setPagination={setPagination}
                            from={from}
                            setFrom={setFrom}
                            lastPage={lastPage}
                            setLastPage={setLastPage}
                            to={to}
                            setTo={setTo}
                            total={total}
                            setTotal={setTotal}
                            page={page}
                            setPage={setPage}
                            status422={status422}
                            setStatus422={setStatus422}
                            opcionesSelector={opcionesSelector}
                            setOpcionesSelector={setOpcionesSelector}
                            añosSelector={añosSelector}
                            setAñosSelector={setAñosSelector}
                            timestamp={timestamp}
                            setTimestamp={setTimestamp}
                        />
                    }
                />
                <Route path="/buscador-experto/*" element={<Navigate to="/buscador-experto" />} />

                {/* PesqueriaDesarrolloPage */}
                <Route
                    path="/pesqueria-desarrollo"
                    element=
                    {
                        <PesqueriaDesarrolloPage
                            verifyToken={verifyToken}
                            selected={selected}
                            setSelected={setSelected}
                            buscador={buscador}
                            setBuscador={setBuscador}
                            options={options}
                            multiSelector={multiSelector}
                            setMultiSelector={setMultiSelector}
                            anioDesde={anioDesde}
                            setAnioDesde={setAnioDesde}
                            anioHasta={anioHasta}
                            setAnioHasta={setAnioHasta}
                            checking={checking}
                            setChecking={setChecking}
                            codigos={codigos}
                            setCodigos={setCodigos}
                            codigosProyectos={codigosProyectos}
                            setCodigosProyectos={setCodigosProyectos}
                            checkboxesProyectos={checkboxesProyectos}
                            setCheckboxesProyectos={setCheckboxesProyectos}
                            proyectos={proyectos}
                            setProyectos={setProyectos}
                            añosDisponibles={añosDisponibles}
                            setAñosDisponibles={setAñosDisponibles}
                            checkboxesAños={checkboxesAños}
                            setCheckboxesAños={setCheckboxesAños}
                            años={años}
                            setAños={setAños}
                            codigosEspecies={codigosEspecies}
                            setCodigosEspecies={setCodigosEspecies}
                            checkboxesEspecies={checkboxesEspecies}
                            setCheckboxesEspecies={setCheckboxesEspecies}
                            especies={especies}
                            setEspecies={setEspecies}
                            codigosPuertos={codigosPuertos}
                            setCodigosPuertos={setCodigosPuertos}
                            checkboxesPuertos={checkboxesPuertos}
                            setCheckboxesPuertos={setCheckboxesPuertos}
                            puertos={puertos}
                            setPuertos={setPuertos}
                            codigosRegiones={codigosRegiones}
                            setCodigosRegiones={setCodigosRegiones}
                            checkboxesRegiones={checkboxesRegiones}
                            setCheckboxesRegiones={setCheckboxesRegiones}
                            regiones={regiones}
                            setRegiones={setRegiones}
                            sorting={sorting}
                            setSorting={setSorting}
                            orderbyAño={orderbyAño}
                            setOrderbyAño={setOrderbyAño}
                            orderbyProyecto={orderbyProyecto}
                            setOrderbyProyecto={setOrderbyProyecto}
                            orderbyInformacion={orderbyInformacion}
                            setOrderbyInformacion={setOrderbyInformacion}
                            orderbyEspecie={orderbyEspecie}
                            setOrderbyEspecie={setOrderbyEspecie}
                            orderbyRegion={orderbyRegion}
                            setOrderbyRegion={setOrderbyRegion}
                            orderbyPuerto={orderbyPuerto}
                            setOrderbyPuerto={setOrderbyPuerto}
                            orderbyRegistros={orderbyRegistros}
                            setOrderbyRegistros={setOrderbyRegistros}
                            orderby={orderby}
                            setOrderby={setOrderby}
                            order={order}
                            setOrder={setOrder}
                            archivos={archivos}
                            setArchivos={setArchivos}
                            loading={loading}
                            setLoading={setLoading}
                            handlePagination={handlePagination}
                            handleSelector={handleSelector}
                            handleChange={handleChange}
                            handleInputChange={handleInputChange}
                            handleSearch={handleSearch}
                            pages={pages}
                            setPages={setPages}
                            pagination={pagination}
                            setPagination={setPagination}
                            from={from}
                            setFrom={setFrom}
                            lastPage={lastPage}
                            setLastPage={setLastPage}
                            to={to}
                            setTo={setTo}
                            total={total}
                            setTotal={setTotal}
                            page={page}
                            setPage={setPage}
                            status422={status422}
                            setStatus422={setStatus422}
                            opcionesSelector={opcionesSelector}
                            setOpcionesSelector={setOpcionesSelector}
                            añosSelector={añosSelector}
                            setAñosSelector={setAñosSelector}
                            timestamp={timestamp}
                            setTimestamp={setTimestamp}
                        />
                    }
                />
                <Route path="/pesqueria-desarrollo/*" element={<Navigate to="/pesqueria-desarrollo" />} />

                {/* PesqueriaNuevoV1Page */}
                <Route
                    path="/pesqueria-nuevo/v1"
                    element={<PesqueriaNuevoV1Page />}
                />
                <Route path="/pesqueria-nuevo/v1/*" element={<Navigate to="/pesqueria-nuevo/v1" />} />

                {/* PesqueriaNuevoV2Page */}
                <Route
                    path="/buscador-publico-v1"
                    element=
                    {
                        <PesqueriaNuevoV2Page
                            verifyToken={verifyToken}
                        />
                    }
                />
                <Route path="/buscador-publico-v1/*" element={<Navigate to="/buscador-publico-v1" />} />

                {/* PesqueriaNuevoV3Page */}
                <Route
                    path="/buscador-publico"
                    element=
                    {
                        <PesqueriaNuevoV3Page
                            verifyToken={verifyToken}
                        />
                    }
                />
                <Route path="/buscador-publico/*" element={<Navigate to="/buscador-publico" />} />

                {/* PoliticasPrivacidadPesqueriaPage */}
                <Route
                    path="/buscador-publico/politicas-privacidad"
                    element={<PoliticasPrivacidadPesqueriaPage />}
                />
                <Route path="/buscador-publico/politicas-privacidad/*" element={<Navigate to="/buscador-publico/politicas-privacidad" />} />

                {/* TerminosUsoPesqueriaPage */}
                <Route
                    path="/buscador-publico/terminos-de-uso"
                    element={<TerminosUsoPesqueriaPage />}
                />
                <Route path="/buscador-publico/terminos-de-uso/*" element={<Navigate to="/buscador-publico/terminos-de-uso" />} />

                {/* PoliticasPrivacidadAcuiculturaPage */}
                <Route
                    path="/acuicultura/politicas-privacidad"
                    element={<PoliticasPrivacidadAcuiculturaPage />}
                />
                <Route path="/acuicultura/politicas-privacidad/*" element={<Navigate to="/acuicultura/politicas-privacidad" />} />

                {/* TerminosUsoAcuiculturaPage */}
                <Route
                    path="/acuicultura/terminos-de-uso"
                    element={<TerminosUsoAcuiculturaPage />}
                />
                <Route path="/acuicultura/terminos-de-uso/*" element={<Navigate to="/acuicultura/terminos-de-uso" />} />

                {/* AcuiculturaPage */}
                <Route
                    path="/acuicultura-v1"
                    element=
                    {
                        <AcuiculturaPage
                            verifyToken={verifyToken}
                            selected={selected}
                            setSelected={setSelected}
                            buscador={buscador}
                            setBuscador={setBuscador}
                            options={options}
                            multiSelector={multiSelector}
                            setMultiSelector={setMultiSelector}
                            anioDesde={anioDesde}
                            setAnioDesde={setAnioDesde}
                            anioHasta={anioHasta}
                            setAnioHasta={setAnioHasta}
                            checking={checking}
                            setChecking={setChecking}
                            codigos={codigos}
                            setCodigos={setCodigos}
                            codigosProyectos={codigosProyectos}
                            setCodigosProyectos={setCodigosProyectos}
                            checkboxesProyectos={checkboxesProyectos}
                            setCheckboxesProyectos={setCheckboxesProyectos}
                            proyectos={proyectos}
                            setProyectos={setProyectos}
                            añosDisponibles={añosDisponibles}
                            setAñosDisponibles={setAñosDisponibles}
                            checkboxesAños={checkboxesAños}
                            setCheckboxesAños={setCheckboxesAños}
                            años={años}
                            setAños={setAños}
                            codigosRegiones={codigosRegiones}
                            setCodigosRegiones={setCodigosRegiones}
                            checkboxesRegiones={checkboxesRegiones}
                            setCheckboxesRegiones={setCheckboxesRegiones}
                            regiones={regiones}
                            setRegiones={setRegiones}
                            codigosSectores={codigosSectores}
                            setCodigosSectores={setCodigosSectores}
                            checkboxesSectores={checkboxesSectores}
                            setCheckboxesSectores={setCheckboxesSectores}
                            sectores={sectores}
                            setSectores={setSectores}
                            sorting={sorting}
                            setSorting={setSorting}
                            orderbyAño={orderbyAño}
                            setOrderbyAño={setOrderbyAño}
                            orderbyProyecto={orderbyProyecto}
                            setOrderbyProyecto={setOrderbyProyecto}
                            orderbyInformacion={orderbyInformacion}
                            setOrderbyInformacion={setOrderbyInformacion}
                            orderbyRegion={orderbyRegion}
                            setOrderbyRegion={setOrderbyRegion}
                            orderbySector={orderbySector}
                            setOrderbySector={setOrderbySector}
                            orderbyRegistros={orderbyRegistros}
                            setOrderbyRegistros={setOrderbyRegistros}
                            orderby={orderby}
                            setOrderby={setOrderby}
                            order={order}
                            setOrder={setOrder}
                            archivos={archivos}
                            setArchivos={setArchivos}
                            loading={loading}
                            setLoading={setLoading}
                            handlePagination={handlePagination}
                            handleSelector={handleSelector}
                            handleChange={handleChange}
                            handleInputChange={handleInputChange}
                            handleSearch={handleSearch}
                            pages={pages}
                            setPages={setPages}
                            pagination={pagination}
                            setPagination={setPagination}
                            from={from}
                            setFrom={setFrom}
                            lastPage={lastPage}
                            setLastPage={setLastPage}
                            to={to}
                            setTo={setTo}
                            total={total}
                            setTotal={setTotal}
                            page={page}
                            setPage={setPage}
                            status422={status422}
                            setStatus422={setStatus422}
                            opcionesSelector={opcionesSelector}
                            setOpcionesSelector={setOpcionesSelector}
                            añosSelector={añosSelector}
                            setAñosSelector={setAñosSelector}
                            timestamp={timestamp}
                            setTimestamp={setTimestamp}
                        />
                    }
                />
                <Route path="/acuicultura-v1/*" element={<Navigate to="/acuicultura-v1" />} />

                {/* AcuiculturaDesarrolloPage */}
                <Route
                    path="/acuicultura-desarrollo"
                    element=
                    {
                        <AcuiculturaDesarrolloPage
                            verifyToken={verifyToken}
                            selected={selected}
                            setSelected={setSelected}
                            buscador={buscador}
                            setBuscador={setBuscador}
                            options={options}
                            multiSelector={multiSelector}
                            setMultiSelector={setMultiSelector}
                            anioDesde={anioDesde}
                            setAnioDesde={setAnioDesde}
                            anioHasta={anioHasta}
                            setAnioHasta={setAnioHasta}
                            checking={checking}
                            setChecking={setChecking}
                            codigos={codigos}
                            setCodigos={setCodigos}
                            codigosProyectos={codigosProyectos}
                            setCodigosProyectos={setCodigosProyectos}
                            checkboxesProyectos={checkboxesProyectos}
                            setCheckboxesProyectos={setCheckboxesProyectos}
                            proyectos={proyectos}
                            setProyectos={setProyectos}
                            añosDisponibles={añosDisponibles}
                            setAñosDisponibles={setAñosDisponibles}
                            checkboxesAños={checkboxesAños}
                            setCheckboxesAños={setCheckboxesAños}
                            años={años}
                            setAños={setAños}
                            codigosRegiones={codigosRegiones}
                            setCodigosRegiones={setCodigosRegiones}
                            checkboxesRegiones={checkboxesRegiones}
                            setCheckboxesRegiones={setCheckboxesRegiones}
                            regiones={regiones}
                            setRegiones={setRegiones}
                            codigosSectores={codigosSectores}
                            setCodigosSectores={setCodigosSectores}
                            checkboxesSectores={checkboxesSectores}
                            setCheckboxesSectores={setCheckboxesSectores}
                            sectores={sectores}
                            setSectores={setSectores}
                            sorting={sorting}
                            setSorting={setSorting}
                            orderbyAño={orderbyAño}
                            setOrderbyAño={setOrderbyAño}
                            orderbyProyecto={orderbyProyecto}
                            setOrderbyProyecto={setOrderbyProyecto}
                            orderbyInformacion={orderbyInformacion}
                            setOrderbyInformacion={setOrderbyInformacion}
                            orderbyRegion={orderbyRegion}
                            setOrderbyRegion={setOrderbyRegion}
                            orderbySector={orderbySector}
                            setOrderbySector={setOrderbySector}
                            orderbyRegistros={orderbyRegistros}
                            setOrderbyRegistros={setOrderbyRegistros}
                            orderby={orderby}
                            setOrderby={setOrderby}
                            order={order}
                            setOrder={setOrder}
                            archivos={archivos}
                            setArchivos={setArchivos}
                            loading={loading}
                            setLoading={setLoading}
                            handlePagination={handlePagination}
                            handleSelector={handleSelector}
                            handleChange={handleChange}
                            handleInputChange={handleInputChange}
                            handleSearch={handleSearch}
                            pages={pages}
                            setPages={setPages}
                            pagination={pagination}
                            setPagination={setPagination}
                            from={from}
                            setFrom={setFrom}
                            lastPage={lastPage}
                            setLastPage={setLastPage}
                            to={to}
                            setTo={setTo}
                            total={total}
                            setTotal={setTotal}
                            page={page}
                            setPage={setPage}
                            status422={status422}
                            setStatus422={setStatus422}
                            opcionesSelector={opcionesSelector}
                            setOpcionesSelector={setOpcionesSelector}
                            añosSelector={añosSelector}
                            setAñosSelector={setAñosSelector}
                            timestamp={timestamp}
                            setTimestamp={setTimestamp}
                        />
                    }
                />
                <Route path="/acuicultura-desarrollo/*" element={<Navigate to="/acuicultura-desarrollo" />} />

                {/* AcuiculturaNuevoV1Page */}
                <Route
                    path="/acuicultura"
                    element=
                    {
                        <AcuiculturaNuevoV1Page
                            verifyToken={verifyToken}
                        />
                    }
                />
                <Route path="/acuicultura/*" element={<Navigate to="/acuicultura" />} />

                {/* DashboardPage */}
                <Route path="/dashboard" element={<DashboardPage verifyToken={verifyToken} />} />
                <Route path="/dashboard/*" element={<Navigate to="/dashboard" />} />

                {/* DashboardAcuiculturaPage */}
                <Route path="/dashboard-acuicultura" element={<DashboardAcuiculturaPage verifyToken={verifyToken} />} />
                <Route path="/dashboard-acuicultura/*" element={<Navigate to="/dashboard-acuicultura" />} />
                <Route path="*" element={<div ref={() => window.location.href = 'https://datos.ifop.cl/'}></div>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
